/* eslint-disable */
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getBrowserType, appLogin, getJavaToken, setJavaTokenFromExternal } from '@/redux/app/appSlice'
import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { WithRouter } from '@/components/WithRouter'

import { checkToken, saveTokenWithTimestamp } from '@/utils/helpers'
import { alignHostErpToken } from '@/utils/auth'
import { refreshTokenByType } from '@/utils/refreshToken'
import Session from '@/utils/session'
import { store } from '@/redux/store'
import { bootstrapPermissionCodes } from '@/utils/bootstrapPermissionCodes'
// Client Page
import ClientPage from '@/views/client/Page'
import Dashboard from '@/views/dashboard/Page'
import CommandCenter from '@/views/commandCenter/Page'
import WorldCommandCenter from '@/views/worldCommandCenter/Page'
import VisualScreen from '@/views/visualScreen/Page'
import ServiceAlertsList from '@/views/commandCenter/profile/ServiceAlerts/ServiceAlertsList'
import VideoProfile from '@/views/commandCenter/profile/ServiceAlerts/VideoProfile'
import CompletionRateAnalyticsList from '@/views/commandCenter/profile/CompletionRateAnalyticsList'
import StaffList from '@/views/commandCenter/profile/StaffList'
import RoomsManagement from '@/views/commandCenter/profile/RoomsManagement'
import ServiceAlertsRulesList from '@/views/tool/ServiceAlertsRulesList'
import OrderList from '@/views/order/orderList/OrderListPage'
import DispatcherList from '@/views/order/dispatcher/DispatcherList'
import DispatcherPageList from '@/views/order/dispatcherPage/DispatcherPageList'
import NewOrdersDispatchMobilePage from '@/views/order/dispatcherPage/mobile/NewOrdersDispatchMobilePage'
import CustomerListPage from '@/views/order/customer/CustomerListPage'
import ServiceNotificationListPage from '@/views/order/serviceNotification/serviceNotificationList'
import SurveillanceList from '@/views/surveillance/List'
import YsDeviceListPage from '@/views/ys/DeviceListPage'
import YsMonitoringLogsPage from '@/views/ys/Log'
import RoleListPage from '@/views/systemControl/roleList/Page'
import PermissionListPage from '@/views/systemControl/permissionList/Page'
import AgentsListPage from '@/views/systemControl/agents/Page'
import TuinaBoardPage from '@/views/tuina/board/Page'
import TuinaAppointmentsPage from '@/views/tuina/appointments/Page'
import TuinaProjectsPage from '@/views/tuina/projects/Page'
import TuinaTechniciansPage from '@/views/tuina/technicians/Page'
import TuinaRosterPage from '@/views/tuina/roster/Page'
import TuinaMembersPage from '@/views/tuina/members/Page'
import TuinaOrdersPage from '@/views/tuina/orders/Page'
// Syetem Page
import LoginPage from '@/views/system/Login'
import DingTPage from '@/views/system/DingT'
import ClientDefaultRedirect from '@/components/ClientDefaultRedirect'

import './App.less'
import './ClientApp.less'

const App = (props) => {
  const { navigate, location } = props
  const dispatch = useDispatch()
  const browserType = useSelector(state => state.app.browserType)
  const reduxToken = useSelector(state => state.app.token)
  const reduxUser = useSelector(state => state.app.user)

  // console.log('App', props, window)
  const [ useFetching, setUseFetching ] = useState(true)
  const [ useDefaultPath, setDefaultPat ] = useState('/client')

  /**
   * 微信小程序 web-view 首屏：
   * - URL 可带 jwt|token、java_token、java_token_exp（与小程序 mergeUrl 一致）。
   * - 小程序 wx.storage 与 H5 隔离，不能直接读；需拼进 src，或由宿主在打开前写入浏览器 localStorage 键名 token / java_token / java_token_exp（与小程序保持一致）。
   * - 从 URL 注入成功后会把 token、java_token 镜像到上述 localStorage，便于下次仅带 storeId 等短参数进页。
   * 必须在其它 effect 判定「未登录」之前同步 cookie + Redux，并拉 Java 票。
   */
  useLayoutEffect(() => {
    if (typeof window === 'undefined') return
    const sp = new URLSearchParams(window.location.search)
    let erp = sp.get('jwt') || sp.get('token')
    let javaFromUrl = sp.get('java_token')
    let javaExpRaw = sp.get('java_token_exp')

    if (!erp || !checkToken(erp)) {
      try {
        const t = localStorage.getItem('token')
        if (t && checkToken(t.trim())) erp = t.trim()
      } catch (_) { /* ignore */ }
    }
    if (erp && checkToken(erp)) {
      if (!javaFromUrl || String(javaFromUrl).trim() === '') {
        try {
          const j = localStorage.getItem('java_token')
          if (j && String(j).trim() !== '') javaFromUrl = j.trim()
        } catch (_) { /* ignore */ }
      }
      if (javaExpRaw == null || String(javaExpRaw).trim() === '') {
        try {
          const e = localStorage.getItem('java_token_exp')
          if (e != null && String(e).trim() !== '') javaExpRaw = e
        } catch (_) { /* ignore */ }
      }
    }

    if (erp && checkToken(erp)) {
      saveTokenWithTimestamp(erp)
      Session.setIkCookie(erp)
      if (reduxUser && Object.keys(reduxUser).length > 0) {
        dispatch(appLogin({ token: erp, user: reduxUser }))
      } else {
        dispatch(appLogin(erp))
      }
      try {
        localStorage.setItem('token', erp)
      } catch (_) { /* ignore */ }
    }

    if (erp && checkToken(erp) && javaFromUrl) {
      dispatch(
        setJavaTokenFromExternal({
          token: javaFromUrl,
          expireTimeAbs: javaExpRaw != null && String(javaExpRaw).trim() !== ''
            ? Number(javaExpRaw)
            : undefined
        })
      )
      try {
        localStorage.setItem('java_token', javaFromUrl)
        if (javaExpRaw != null && String(javaExpRaw).trim() !== '') {
          localStorage.setItem('java_token_exp', String(javaExpRaw))
        }
      } catch (_) { /* ignore */ }
    }

    const hadAuthQuery =
      sp.has('jwt') ||
      sp.has('token') ||
      sp.has('java_token') ||
      sp.has('java_token_exp')
    if (hadAuthQuery) {
      sp.delete('jwt')
      sp.delete('token')
      sp.delete('java_token')
      sp.delete('java_token_exp')
      const rest = sp.toString()
      const next =
        `${location.pathname}${rest ? `?${rest}` : ''}${location.hash || ''}`
      const prev = `${location.pathname}${location.search}${location.hash || ''}`
      if (next !== prev) {
        navigate(next, { replace: true })
      }
    }

    if (erp && checkToken(erp) && !javaFromUrl) {
      dispatch(getJavaToken())
    }

    alignHostErpToken()
  // 仅挂载时消费一次 URL 上的票 + 对齐小程序同名 localStorage 键
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 仅刷新 Java / 萤石 token（启动 + 切回前台）；与 RBAC codes-by-type 解耦，不在此拉权限码
  // 依赖数组只保留 reduxToken 和 dispatch，不包含 expireTime
  // 原因：token 刷新成功会更新 expireTime，如果 expireTime 在依赖数组中会重新触发 useEffect → 无限循环
  // refreshTokenByType 内部直接读取 Redux store 获取最新 expireTime，无需通过 React 状态传递
  useEffect(() => {
    const isLoginReady = () => {
      const token = reduxToken || Session.readHostIk()
      return !!token && checkToken(token)
    }

    const refreshJavaToken = () => {
      if (!isLoginReady()) return
      refreshTokenByType('java').catch(err => {
        console.warn('[App] Java token 刷新失败:', err)
      })
    }
    
    const refreshYs7Token = () => {
      if (!isLoginReady()) return
      refreshTokenByType('ys7').catch(err => {
        console.warn('[App] 萤石云 token 刷新失败:', err)
      })
    }

    const refreshAllTokens = () => {
      if (!isLoginReady()) return
      refreshJavaToken()
      refreshYs7Token()
    }

    refreshAllTokens()

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        refreshAllTokens()
      }
    }

    const handleFocus = () => {
      refreshAllTokens()
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('focus', handleFocus)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('focus', handleFocus)
    }
  }, [reduxToken, dispatch])

  // RBAC（/system/rbac/codes-by-type）：与 token 刷新、切标签无关；整页刷新（F5）时 store 会重置 permissionCodesLoaded，此处与 ClientDefaultRedirect 会再拉一次。
  // ① /client/* 未加载过权限码时补拉；② 从 /dashboard、/、/client 进入时重拉。
  // 不把 permissionCodesFetching / permissionCodesLoaded 放进依赖，避免 fetch 完成后 effect 再跑一遍导致重复请求；并发用 getState() 判断。
  useEffect(() => {
    const pathname = location?.pathname || ''
    const token = reduxToken || Session.readHostIk()
    if (!token || !checkToken(token)) return
    const appState = store.getState().app
    if (appState.permissionCodesFetching) return

    const isEntryResync =
      pathname === '/dashboard' ||
      pathname === '/' ||
      pathname === '/client'

    if (isEntryResync) {
      bootstrapPermissionCodes(store)
      return
    }

    if (pathname.startsWith('/client') && !appState.permissionCodesLoaded) {
      bootstrapPermissionCodes(store)
    }
  }, [location?.pathname, reduxToken])

  useEffect(() => {
    dispatch(getBrowserType())
    alignHostErpToken()
    const tokenNow = store.getState().app.token
    const isCheckJwt = checkToken(tokenNow) || checkToken(Session.readHostIk())
    /**
     * 不能用 先判 未登录方法
     * if (!isCheckJwt) { XXXXX }
     * 路由器不会再次渲染 登陆dom
     * 路由器只会更改 地址
     * 以后找到办法修改 在做
     */

    if (isCheckJwt) {
      // const fetchData = async()=> {
      //   const { value: { data } } = await props.getAppRoles({appKey: 'crm'})
      //   const isUser = ['NORMAL_USER', 'ADMIN'].some(role => data.indexOf(role) > -1)
      //   switch (true) {
      //     // 钉钉环境
      //     case (browserType.environment === 'dingtalk' && browserType.client === 'pc'): {
      //       setDefaultPat('/system/dingT')
      //       return
      //     }
      //     // 冇权限
      //     case !isUser: {
      //       // 强制跳转 错误页面
      //       navigate('/system/error')
      //       setDefaultPat('/system/error')
      //       return
      //     }
      //   }
      // }
      // /**
      //  * 执行项目 权限请求 校验
      //  * */
      // fetchData()

    } else {
      // 未登陆
      setDefaultPat('/system/login')
    }

    setUseFetching(false)
  }, [useFetching])
  return (
    <div className="i2-App">
      <Routes>
        <Route exact path='/' element={<Navigate exact to={useDefaultPath}/>}/>
        <Route path='/client' element={<ClientDefaultRedirect />}/>

        <Route path="/client/*" element={<ClientPage/>}>
          {/* 将更具体的子路由放在前面，避免父路由被匹配 */}
          <Route path="staffList" element={<StaffList/>}/>
          <Route path="serviceAlertsRulesList" element={<ServiceAlertsRulesList/>}/>
          <Route path="roomsManagement" element={<RoomsManagement/>}/>
          <Route path="commandCenter/serviceAlertsList" element={<ServiceAlertsList/>}/>
          <Route path="commandCenter/completionRateAnalyticsList" element={<CompletionRateAnalyticsList/>}/>
          <Route path="commandCenter" element={<CommandCenter/>}/>
          <Route path="worldCommandCenter" element={<WorldCommandCenter/>}/>
          <Route path="visualScreen" element={<VisualScreen/>}/>
          <Route path="ServiceAlerts/VideoProfile" element={<VideoProfile/>}/>
          <Route path="order/orderList" element={<OrderList/>}/>
          <Route path="order/dispatchManagement" element={<DispatcherList/>}/>
          <Route path="order/dispatch" element={<DispatcherPageList/>}/>
          <Route path="order/dispatchNewOrdersMobile" element={<NewOrdersDispatchMobilePage/>}/>
          <Route path="order/customerList" element={<CustomerListPage/>}/>
          <Route path="order/serviceNotification" element={<ServiceNotificationListPage/>}/>
          <Route path="ys7/devices" element={<YsDeviceListPage/>}/>
          <Route path="ys7/log" element={<YsMonitoringLogsPage/>}/>
          <Route path="surveillance/list" element={<SurveillanceList/>}/>
          <Route path="tuina/board" element={<TuinaBoardPage/>}/>
          <Route path="tuina/appointments" element={<TuinaAppointmentsPage/>}/>
          <Route path="tuina/orders" element={<TuinaOrdersPage/>}/>
          <Route path="tuina/projects" element={<TuinaProjectsPage/>}/>
          <Route path="tuina/technicians" element={<TuinaTechniciansPage/>}/>
          <Route path="tuina/roster" element={<TuinaRosterPage/>}/>
          <Route path="tuina/shifts" element={<Navigate to="/client/tuina/roster" replace />}/>
          <Route path="tuina/members" element={<TuinaMembersPage/>}/>
          <Route path="tuina" element={<Navigate to="/client/tuina/board" replace />}/>
          <Route path="massage/board" element={<Navigate to="/client/tuina/board" replace />}/>
          <Route path="massage/appointments" element={<Navigate to="/client/tuina/appointments" replace />}/>
          <Route path="massage/orders" element={<Navigate to="/client/tuina/orders" replace />}/>
          <Route path="massage/projects" element={<Navigate to="/client/tuina/projects" replace />}/>
          <Route path="massage/technicians" element={<Navigate to="/client/tuina/technicians" replace />}/>
          <Route path="massage/roster" element={<Navigate to="/client/tuina/roster" replace />}/>
          <Route path="massage/shifts" element={<Navigate to="/client/tuina/roster" replace />}/>
          <Route path="massage/members" element={<Navigate to="/client/tuina/members" replace />}/>
          <Route path="massage" element={<Navigate to="/client/tuina/board" replace />}/>
          <Route path="systemControl/roleList" element={<RoleListPage/>}/>
          <Route path="systemControl/permissionList" element={<PermissionListPage/>}/>
          <Route path="systemControl/agents" element={<AgentsListPage/>}/>

        </Route>
        <Route path="/dashboard" element={<Dashboard/>}/>
        <Route path="/system/*" element={<Outlet/>}>
          <Route path="login" element={<LoginPage/>}/>
          <Route path="dingT" element={<DingTPage/>}/>
        </Route>
      </Routes>
    </div>
  )
}
export default WithRouter(App)
